import { CpUserDataInterface } from '../../../interfaces/dto/user-data/cp-user-data-interface';

export class CpUserDataModel implements CpUserDataInterface {
  Address: string = '';
  Birthdate: string = '';
  City: string = '';
  Email: string = '';
  FiscalNumber: string = '';
  FiscalNumberCountryCode: string = '';
  Gender: string = '';
  Iban: string = '';
  Mobile: string = '';
  Name: string = '';
  NationalCardNumber: string = '';
  NationalCardNumberCountryCode: string = '';
  PostalCode: string = '';

  constructor(init?: Partial<CpUserDataModel>) {
    Object.assign(this, init);
  }
}
